import { Avatar, Box, Button, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import profile_banner from "../../../Assets/profile_banner.png"
import profile_image from "../../../Assets/Media.jpg"
import "./HomeProfile.css"
import { TfiLocationPin } from "react-icons/tfi";
import { AiOutlineChrome } from "react-icons/ai";
import { CiCalendarDate } from "react-icons/ci";
import { MdOutlineWorkOutline } from "react-icons/md";
import { TbHeartPlus } from "react-icons/tb";
import { useDispatch, useSelector } from 'react-redux'
import actions from '../../../ReduxStore/actions'
import { useNavigate } from 'react-router-dom'
import EditProfileBannerModal from '../EditProfile/EditProfileBannerModal'
import { adminUrl } from '../../../constants'
import { BiPencil } from 'react-icons/bi'
import EditProfileAboutMeModal from '../EditProfile/EditProfileAboutMeModal'


const HomeProfile = () => {


    const { getUserById } = useSelector(state => state?.getUserById);

    console.log(getUserById, "getUserByIdgetUserById")
    const menuItems = [
        { text: getUserById?.data?.present_country, icon: TfiLocationPin },
        { text: 'dribble.com/preethi', icon: AiOutlineChrome },
        { text: 'Joined June 2012', icon: CiCalendarDate },
        { text: 'Working at Cygnusa', icon: MdOutlineWorkOutline },
        { text: 'In relationship', icon: TbHeartPlus }

    ];

    const dispatch = useDispatch()
    const sessionUserId = sessionStorage.getItem("userId")
    const { createFeed } = useSelector(
        (state) => state?.createFeed
    );

    const { getUserStatsCount } = useSelector(
        (state) => state?.getUserStatsCount
    );

    const { likeFeed } = useSelector(
        (state) => state?.likeFeed
    );

    const { unlikeFeed } = useSelector(
        (state) => state?.unlikeFeed
    );

    const { commentOnFeed } = useSelector(
        (state) => state?.commentOnFeed
    );
    const { replyToComment } = useSelector(
        (state) => state?.replyToComment
    );

    const { updateUserStoreInfo } = useSelector(
        (state) => state?.updateUserStoreInfo
    );

    const { getUserProfileBanner } = useSelector(
        (state) => state?.getUserProfileBanner
    );
    const { getUserAbout } = useSelector(
        (state) => state?.getUserAbout
    );


    const navigate = useNavigate()

    useEffect(() => {

        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUserStatsCount/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETUSERSTATUSCOUNT(data1));

        }
        fetchData()
    }, [createFeed, likeFeed, unlikeFeed, commentOnFeed, replyToComment])

    useEffect(() => {

        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUserProfileBanner/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETUSERPROFILEBANNER(data1));

            const data2 = {
                data: {},
                method: "get",
                apiName: `getUserAbout/${sessionUserId}`,
            };
            const response1 = await dispatch(actions.GETUSERABOUT(data2));

        }
        fetchData()
    }, [updateUserStoreInfo])

    const [editprofileBannerOpen, setEitprofileBannerOpen] = useState(false)
    const hadleEitprofileBannerOpen = () => {
        setEitprofileBannerOpen(true)
    }
    const hadleEitprofileBannerClose = () => {
        setEitprofileBannerOpen(false)
    }
    const [editprofileAboutMeOpen, setEitprofileAboutMeOpen] = useState(false)
    const hadleEitprofileAboutMeOpen = () => {
        setEitprofileAboutMeOpen(true)
    }
    const hadleEitprofileAboutMeClose = () => {
        setEitprofileAboutMeOpen(false)
    }




    return (
        <Box
            sx={{
                width: "100%",
                // border:'1px solid gray'
                boxShadow: 4,
                background: "white"
            }}
        >
            <Box

                sx={{
                    position: "relative",
                    // boxShadow: 4,
                    height: "200px",
                    width: "100%",
                    borderRadius: "10px",
                    backgroundImage: `url(${adminUrl}${getUserProfileBanner?.data})`,
                    backgroundSize: "cover", // optional
                    backgroundPosition: "center", // optional
                    borderBottom: "1px solid gray"

                }}

            >
                <Box sx={{
                    position: "absolute",
                    bottom: "-59px",
                    display: "flex",
                    // alignItems: "center",
                    marginLeft: {
                        xs: 0,
                        sm: "19px",
                        md: "19px"
                    },
                    marginRight: {
                        xs: 0,
                        sm: "14px",
                        md: "14px"
                    },
                    padding: "10px",
                    // Apply boxShadow only on screen sizes 'sm' and up (not on mobile)
                }}>
                    <Box mr={2}>

                        <Avatar src={`${adminUrl}${getUserById?.data?.profileImage}`}
                            sx={{
                                // bgcolor: "white",
                                border: "1px solid lightgray",
                                height: "150px", width: "150px",
                                "& .MuiAvatar-img": {
                                    objectFit: "contain"
                                }

                            }}></Avatar>

                    </Box>
                    {/* <Box>
                        <Typography variant="subtitle2" sx={{
                            fontSize: "17px",
                            color: "black",
                            fontWeight: 600
                        }}>{getUserById?.data?.first_name} {getUserById?.data?.last_name}</Typography>
                        <Typography sx={{
                            color: "black",

                        }} >@{getUserById?.data?.first_name}</Typography>
                    </Box> */}
                </Box>
                <Box sx={{
                    position: "absolute",
                    top: "10px",
                    right: "10px"

                }}>
                    <Button
                        onClick={() => {
                            // navigate("/user/editprofile")
                            hadleEitprofileBannerOpen()
                        }}
                        sx={{
                            backgroundColor: "black",
                            color: "white",
                            padding: "1px"
                        }}
                    >
                        Edit
                    </Button>
                </Box>
            </Box>
            <Grid
                container
                spacing={2}
                sx={{
                    //     display: "flex",
                    //     justifyContent: "space-between",
                    mt: { xs: 7,md:1 }
                }}
            >
                <Grid size={{ md: 3 }}></Grid>
                <Grid size={{ md: 4 }}>
                    <Typography variant="subtitle2" sx={{
                        fontSize: "17px",
                        color: "black",
                        fontWeight: 600
                    }}>{getUserById?.data?.first_name} {getUserById?.data?.last_name}</Typography>
                    <Typography sx={{
                        color: "black",

                    }} >@{getUserById?.data?.first_name}</Typography>
                </Grid>
                <Grid size={{ xs: 5 }} sx={{ display: "flex" }}>
                    <Box
                        sx={{
                            marginRight: "20px"
                        }}
                    >
                        <Typography
                            variant='subtitle2'
                            className='post_followers_text'
                        // sx={{
                        //     color: "black",
                        //     fontWeight: 800
                        // }}
                        >
                            Posts
                        </Typography>
                        <Typography
                            variant='subtitle2'

                            sx={{
                                color: "black",
                                textAlign: "center"

                            }}
                        >
                            {getUserStatsCount?.data?.postCount || 0}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            marginRight: "20px"
                        }}
                    >
                        <Typography
                            variant='subtitle2'
                            className='post_followers_text'
                        >
                            Connections
                        </Typography>
                        <Typography
                            variant='subtitle2'
                            sx={{
                                color: "black",
                                textAlign: "center"

                            }}
                        >
                            {getUserStatsCount?.data?.connectionCount || 0}

                        </Typography>
                    </Box>
                    <Box

                        sx={{
                            marginRight: "20px"
                        }}
                    >
                        <Typography
                            variant='subtitle2'
                            className='post_followers_text'

                        >
                            Likes
                        </Typography>
                        <Typography
                            variant='subtitle2'

                            sx={{
                                color: "black",
                                textAlign: "center"

                            }}

                        >
                            {getUserStatsCount?.data?.likeCount || 0}

                        </Typography>
                    </Box>

                </Grid>
            </Grid>
            <Grid padding={2}>
                <Grid>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Typography variant='subtitle2' sx={{ color: "black", fontSize: "20px" }}>About me</Typography>
                        <BiPencil style={{ fontSize: "14px" }} onClick={hadleEitprofileAboutMeOpen} />
                    </Box>
                    <Typography variant='body1'
                        sx={{ color: "gray" }}
                    >
                        {getUserAbout?.data}

                        {/* "Dedicated professor with a passion for inspiring learning, fostering research, and empowering students to achieve academic and professional excellence"*/}
                    </Typography>



                </Grid>
                {/* <Grid container>
                    {menuItems.map((items, index) => (
                        <Grid size={{ xs: 12, md: 3 }} sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                            <items.icon />
                            <Typography>
                                {items.text}
                            </Typography>
                        </Grid>
                    ))}

                </Grid> */}

            </Grid>
            <EditProfileBannerModal
                open={editprofileBannerOpen}
                onClose={hadleEitprofileBannerClose}
            />
            <EditProfileAboutMeModal
                open={editprofileAboutMeOpen}
                onClose={hadleEitprofileAboutMeClose}
            />
        </Box>
    )
}

export default HomeProfile